<script lang="ts" setup>
import { i18n } from '@/i18n';
import TextInput from '@/unmanagedBusinessModule/components/TextInput.vue';
import SimpleSelectInput from '@/corePagesModule/components/SelectInput.vue';
import TextIconButton from '@/corePagesModule/components/TextIconButton.vue';
import { useAddOptionSection } from '@/corePagesModule/updateBusinessModal/composables/useAddOptionSection';

const t = i18n.t;

// eslint-disable-next-line jsdoc/require-jsdoc
const props = withDefaults(defineProps<{ isAggregateBusiness?: boolean; options?: string[]; disabled?: boolean }>(), { options: () => [] });

const emits = defineEmits<{
  (e: 'setOption', type: string, name: string, code?: string): void;
}>();

const {
  fieldState,
  isAnotherInputShow,
  optionFieldCount,
  isAddButtonActive,
  textStyle,
  buttonStyle,
  AddableOptions,
  updateInput,
  addOption,
} = useAddOptionSection(emits, { isAggregateBusiness: props.isAggregateBusiness, customOption: props.options });
</script>
<template>
  <div>
    <div class="section__container">
      <div class="section__input__container">
        <TextInput
          class="section__input"
          :model-value="fieldState['value'].value.value"
          label=""
          :placeholder="t('新規選択肢')"
          :is-error="fieldState['value'].isError.value"
          :error-message="fieldState['value'].errorMessage.value"
          :disabled="disabled"
          @update:model-value="
            (e) => {
              updateInput(e, 'value');
            }
          "
        />
        <span :style="textStyle">{{ t('を') }}</span>
        <SimpleSelectInput
          class="section__input"
          :model-value="fieldState['option'].value.value"
          :index="99"
          label=""
          :options="AddableOptions"
          select-box-name="SELECT_COLUMN_FOR_NEW_SELECTION"
          :placeholder="t('必須項目から選択')"
          display-allow
          :disabled="disabled"
          @update:model-value="
            (e) => {
              updateInput(e, 'option');
            }
          "
        />
        <span :style="textStyle"
          >{{ t('として') }}<span v-if="isAnotherInputShow">{{ t('、') }}</span>
        </span>
        <template v-if="isAnotherInputShow">
          <TextInput
            class="section__input"
            :model-value="fieldState['anotherValue'].value.value"
            label=""
            :placeholder="t('新規選択肢')"
            :is-error="fieldState['anotherValue'].isError.value"
            :error-message="fieldState['anotherValue'].errorMessage.value"
            :disabled="disabled"
            @update:model-value="
              (e) => {
                updateInput(e, 'anotherValue');
              }
            "
          />
          <span :style="textStyle">{{ t('を') }}</span>
          <TextInput class="section__input" :model-value="fieldState['anotherOption'].value.value" label="" disabled />
          <span :style="textStyle">{{ t('として') }}</span>
        </template>
        <span :style="textStyle">{{ t('上記のセクションに新規選択肢を追加できます。') }}</span>
        <TextIconButton
          :style="buttonStyle"
          :text="t('追加')"
          icon="plusIconWhite"
          :prop-disabled="!isAddButtonActive"
          @click="addOption"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.section {
  &__container {
    display: grid;
    width: 100%;

    padding: 8px 16px;
    border-radius: 8px;
    gap: 8px;

    background-color: $backgroundDefault;
  }
  &__input {
    align-self: end;
    &__container {
      display: grid;
      grid-template-columns: repeat(v-bind(optionFieldCount), 160px max-content 160px max-content) max-content max-content;
      align-items: center;
      gap: 8px;
    }
  }
}
</style>
